export const handlePrintErrors = (err) => {
    if (typeof err === 'string') {
        return err;
    }

    if (Array.isArray(err)) {
        return err.map(e => handlePrintErrors(e)).join('\n');
    }

    if (typeof err === 'object' && err !== null) {
        if(err?.errors && typeof err?.errors === 'string') {
          return err.errors;
        }
        return Object.entries(err)
            .map(([key, value]) => `${key}: ${handlePrintErrors(value)}`)
            .join('\n');
    }

    return String(err);
};